import { useTranslation } from 'react-i18next';
import { resources } from '../../../resources/resources';
import ImportOrdersFileForm from './Components/ImportOrdersFileForm';

export default function ImportOrdersPage() {
  const { t: translate } = useTranslation();
  return (
    <div className="panel padding-xl uploads-panel">
      <h1>{translate(resources.admin.importOrders.title)}</h1>
      <ImportOrdersFileForm />
    </div>
  );
}
